// The school's logo comes from the identity endpoint, never from a bundled
// asset: this build is deployed for every client, and an imported logo
// would ship one school's crest to all of them.
import { SchoolLogo, useIdentity } from "../identity/IdentityProvider"
import { Link, matchPath, useNavigate  } from 'react-router-dom'
import { IoIosArrowDown } from "react-icons/io";
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import { FaPlus} from "react-icons/fa";

const Header = () => {
  const user = useSelector(state => state.user.details);
  const identity = useIdentity();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <section className="bg-lightAqua rounded-b-lg">
      <div className="max-w-7xl mx-auto px-4 my-2 flex justify-between">
        <Link to="/dashboard" className="flex items-center gap-2 no-underline text-gray-200">
          <SchoolLogo className="w-fit h-14 bg-white rounded p-1" />
          <h1 className="font-semibold text-2xl m-0 max-lg:hidden">
            {identity.shortName ? `${identity.shortName} - Interactive Videos` : "Interactive Videos"}
          </h1>
        </Link>

        <div className="flex justify-center gap-6 text-gray-200 font-semibold text-lg max-md:hidden">
          <button className={`${matchPath('/dashboard/video', pathname) && 'header-link'}`} onClick={()=>navigate("/dashboard/video")}>School Videos</button>
          <button className={`${matchPath('/dashboard/lesson', pathname) && 'header-link'}`} onClick={()=>navigate("/dashboard/lesson")}>School Lessons</button>
          <button className={`${matchPath('/dashboard/lesson/library', pathname) && 'header-link'}`} onClick={()=>navigate("/dashboard/lesson/library")}>My Lessons</button>
        </div>

        <div className="flex items-center md:hidden">
          <div className="dropdown dropdown-bottom dropdown-hover">
            <div tabIndex={0} role="button" className="flex items-center gap-2 text-gray-200 font-semibold text-lg">
              <p className="m-0">Go To</p>
              <IoIosArrowDown fontSize={18} />
            </div>
            <div tabIndex={0} className="dropdown-content z-10 menu p-2 shadow bg-gray-50 rounded-box min-w-36">
              <button className="dropdown-button" onClick={()=>navigate("/dashboard/video")}>School Videos</button>
              <button className="dropdown-button" onClick={()=>navigate("/dashboard/lesson")}>School Lessons</button>
              <button className="dropdown-button" onClick={()=>navigate("/dashboard/lesson/library")}>My Lessons</button>
            </div>
          </div>
        </div>

        <div className="flex justify-end items-center">
          {
            (user?.roleId == 1 || user?.roleId == 2) &&
            <Link to="/new-video" className="rounded-full bg-yellow-400 active:bg-yellow-500 px-3 py-1 flex justify-center gap-2 items-center font-semibold text-gray-900 no-underline">
              <FaPlus fontSize={14} />
              <div>
                <span className="max-sm:hidden">New</span> Video
              </div>
            </Link>
          }
        </div>
      </div>
    </section>
  )
}

export default Header